import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppService, AppSettingService } from '../../app.service';
import { FileManagementApiService } from '../../fileManagement/file-management-api.service';
import { FileManagementService } from '../../fileManagement/file-management.service';

@Component({
	selector: 'app-action-more-rename-folder',
	templateUrl: "./action-more-rename-folder.component.html",
	standalone: false
})
export class ActionMoreRenameFolderComponent implements OnInit {
	@Input() folderData: any;
	constructor(
		private router: Router,
		private fileManagementApiService: FileManagementApiService,
		private fileManagementService: FileManagementService
	) { }

	onSelected() {		
		this.fileManagementService.confirmRenameFolder(this.folderData.FolderName).then(
			(response) => {
				if (response.isConfirmed === true && response.value.trim().length > 0) {
					const renamedFolderName = response.value;
					this.fileManagementApiService.renameFolder(this.folderData.FolderId, renamedFolderName).subscribe(
						(response) => {
							this.fileManagementService.emitFolderRenamedEvent(this.folderData);
						},
						(error) => {
							console.log(error);
						}
					);
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	ngOnInit(): void {		
	}
}
